var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddSubjectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43C33.598 43 43 33.598 43 22Z",
    fill: "#EF52DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43C33.598 43 43 33.598 43 22Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7857 12C14.4196 12 12.5 13.6797 12.5 15.75V28.25C12.5 30.3203 14.4196 32 16.7857 32H29.6429H31.0714C31.8616 32 32.5 31.4414 32.5 30.75C32.5 30.0586 31.8616 29.5 31.0714 29.5V27C31.8616 27 32.5 26.4414 32.5 25.75V13.25C32.5 12.5586 31.8616 12 31.0714 12H29.6429H16.7857ZM16.7857 27H28.2143V29.5H16.7857C15.9955 29.5 15.3571 28.9414 15.3571 28.25C15.3571 27.5586 15.9955 27 16.7857 27ZM18.2143 17.7938C18.2143 17.45 18.5357 17 18.9286 17H27.5C27.8929 17 28.2143 17.45 28.2143 17.7938C28.2143 18.1375 27.8929 18.5 27.5 18.5H18.9286C18.5357 18.5 18.2143 18.1375 18.2143 17.7938ZM18.9286 20H27.5C27.8929 20 28.2143 20.4187 28.2143 20.7624C28.2143 21.1062 27.8929 21.5 27.5 21.5H23H19C18.6071 21.5 18.2143 21.1062 18.2143 20.7624C18.2143 20.4187 18.5357 20 18.9286 20Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSubjectIcon);
export default __webpack_public_path__ + "static/media/add-subject-icon.77c8cfb1a8fe3611aba6c0582c17bda6.svg";
export { ForwardRef as ReactComponent };